import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';

import React from 'react';
import PropTypes from 'prop-types';

import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Text, TextType } from 'ui-components/components/text';

import { OrderDetailsAddToBatchDropdownContainer } from '../../../components/add-to-batch-dropdown/order-details-add-to-batch-dropdown.container';
import { headerButtons } from '../messages';
import style from './order-details-nav-bar.module.less';

const unstyled = THEME_CONSTANTS.unstyled;
const menuPosition = 'bottom-right';

// the container wraps our HeaderButton in a DropdownMenuToggler which has its own tabIndex
// but does not have our :focus-within styling, so here we remove that wrapper's tabbability
const tabIndexForWrapper = -1;

export const BatchAll = ({ salesOrderId, shipmentCount = 0 }) => (
  <OrderDetailsAddToBatchDropdownContainer
    menuPosition={menuPosition}
    salesOrderId={salesOrderId}
    tabIndex={tabIndexForWrapper}
    togglerClassName={style.header}
    togglerOpenClassname={style.selected}
    togglerTheme={unstyled}
  >
    <div className={style['header-button']}>
      <FontAwesomeIcon icon={faLayerGroup} />
      <Text formattedMessageValues={{ shipmentCount }} textType={TextType.Paragraph} value={headerButtons.batch} />
    </div>
  </OrderDetailsAddToBatchDropdownContainer>
);

BatchAll.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
  shipmentCount: PropTypes.number,
};
